/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Locations API
 * AV Services Locations management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  DocumentsControllerDeleteSpaceDocumentV1Params,
  DocumentsControllerDeleteSpaceDocumentV1PathParameters,
  DocumentsControllerGetSpaceDocumentDataV1PathParameters,
  DocumentsControllerGetSpaceDocumentsV1200,
  DocumentsControllerGetSpaceDocumentsV1PathParameters,
  DocumentsControllerUploadSpaceDocumentV1201,
  DocumentsControllerUploadSpaceDocumentV1Params,
  DocumentsControllerUploadSpaceDocumentV1PathParameters,
} from '../models';

@Injectable({ providedIn: 'root' })
export class DocumentsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve all documents for a specific space
   */

  getSpaceDocuments<TData = DocumentsControllerGetSpaceDocumentsV1200>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    locationId,
    spaceId,
  }: DocumentsControllerGetSpaceDocumentsV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}/spaces/${spaceId}/documents`);
  }
  /**
   * @summary Upload a document for a space
   */

  uploadSpaceDocument<TData = DocumentsControllerUploadSpaceDocumentV1201>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, locationId, spaceId }: DocumentsControllerUploadSpaceDocumentV1PathParameters,
    documentsControllerUploadSpaceDocumentV1Body: Blob,
    params?: DocumentsControllerUploadSpaceDocumentV1Params,
  ): Observable<TData> {
    return this.http.post<TData>(
      `/locations/v1/clients/${clientId}/locations/${locationId}/spaces/${spaceId}/documents`,
      documentsControllerUploadSpaceDocumentV1Body,
      {
        params: (() => {
          const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
          for (const [key, value] of Object.entries(params ?? {})) {
            if (Array.isArray(value)) {
              const filtered = value.filter(
                item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
              ) as Array<string | number | boolean>;
              if (filtered.length) {
                filteredParams[key] = filtered;
              }
            } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
              filteredParams[key] = value;
            }
          }
          return filteredParams;
        })(),
      },
    );
  }
  /**
   * @summary Retrieve a specific document by filename
   */

  getSpaceDocumentData<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    locationId,
    spaceId,
    fileName,
  }: DocumentsControllerGetSpaceDocumentDataV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}/spaces/${spaceId}/documents/${fileName}`);
  }
  /**
   * @summary Delete a document from a space
   */

  deleteSpaceDocument<TData = void>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, locationId, spaceId, filename }: DocumentsControllerDeleteSpaceDocumentV1PathParameters,
    params: DocumentsControllerDeleteSpaceDocumentV1Params,
  ): Observable<TData> {
    return this.http.delete<TData>(`/locations/v1/clients/${clientId}/locations/${locationId}/spaces/${spaceId}/documents/${filename}`, {
      params: (() => {
        const filteredParams: Record<string, string | number | boolean | Array<string | number | boolean>> = {};
        for (const [key, value] of Object.entries(params ?? {})) {
          if (Array.isArray(value)) {
            const filtered = value.filter(
              item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
            ) as Array<string | number | boolean>;
            if (filtered.length) {
              filteredParams[key] = filtered;
            }
          } else if (value != null && (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')) {
            filteredParams[key] = value;
          }
        }
        return filteredParams;
      })(),
    });
  }
}
